export default __webpack_public_path__ + "efbb3c0b5ed932f89070b4c8f7f6adda.png";